import { useCallback } from 'react';

export const useTimeFormatter = () => {
  const formatTime = useCallback((time: number): string => {
    if (isNaN(time) || !isFinite(time)) return "--:--";

    const absTime = Math.floor(Math.abs(time));
    const hours = Math.floor(absTime / 3600);
    const minutes = Math.floor((absTime % 3600) / 60);
    const seconds = absTime % 60;

    if (hours > 0) {
      return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
    } else {
      return `${minutes}:${seconds.toString().padStart(2, "0")}`;
    }
  }, []);

  return { formatTime };
};
